import React,{useState,useEffect} from 'react'
import {FiChevronRight} from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import { GetBlogServices } from '../folder/services/BlogServices'
import { Pagination } from 'antd'



function Blogs() {

  const [datas,setdatas] = useState({datas:[]})
  const [page,setpage] = useState(1)
  const navigator = useNavigate()  

  useEffect(()=>{
    getData()
  },[page])

  async function getData(){
    const response = await GetBlogServices(page,'')
    setdatas(response?.data)
  }


  async function openDetail(v){
    navigator(`/blogs/detail/${v?._id}`)
  }


  return (
    <div className="w-full h-full overflow-hidden">
        <div className='relative h-[30vh] md:min-h-[60vh] md:max-h-[60vh] relative bg-blogs-bg bg-cover bg-no-repeat bg-right-bottom'>
          
          <div className='absolute  top-[6%] left-[10%]'>
          <h6 className='font_normal group text-white text-[13px] 2xl:text-[16px] flex items-center'><span onClick={()=>navigator('/')} className='opacity-70 hover:opacity-100 hover:underline cursor-pointer'>Home</span> <FiChevronRight className='mx-2' />  <span className='opacity-70 hover:opacity-100 hover:underline cursor-pointer'>Blogs</span>  </h6>  
          </div>

          <div className='bg-black/40 w-full h-full '>

          </div>
          <h1 className='text-white flex font_normal text-[13px] 2xl:text-[16px] p-6 bg-black px-10 md:text-[16px] absolute bottom-0 left-[10%] bg-opacity-70'><span className='min-w-[4px] block min-h-[18px] max-h-[35px] rounded mt-[-1px] mr-4 bg-[#fff]'></span> The Hand Picked success stories by fidelitus which might inspires you and believe in us </h1>
        </div>

        <div className='w-[80%] my-10 mx-auto'>
        <h1 className='flex  font_normal text-[13px] py-6 md:text-[16px] 2xl:text-[19px] '><span className='min-w-[4px] block min-h-[18px] max-h-[35px] rounded mt-[-1px] mr-4 bg-[#027d9b]'></span> The Hand Picked success stories by fidelitus which might inspires you and believe in us </h1>

        <div className='grid grid-cols-1 mb-6 md:grid-cols-5 md:gap-3'>
            {datas?.datas?.slice(0,4)?.map((b,i)=>(
                <div data-aos="fade-left" onClick={()=>openDetail(b)} className={`${i == 0 ? 'col-span-1 md:col-span-2' : 'col-span-1'} w-[100%] mb-4 md:mb-0 relative cursor-pointer`}>
                  
                   <img src={`${process.env.REACT_APP_AWS_IMAGE_URL}${b?.blog_image}`} className={` ${i == 0 ? 'h-[260px]' : 'h-[160px]'} w-[100%]`} />
                   <div >
                    {i == 0 ? 
                    <div className='bg-black/30 absolute bottom-0'>
                        <h6 className='font_normal font-[700] text-[#fff] capitalize  text-[13px] 2xl:text-[16px] break-all w-[85%] ml-5 pt-4'>{b?.title}</h6>
                        <h6  className='font_normal mb-2 ml-5 font-[700] text-[#fff] text-[11px] 2xl:text-[14px]'>{b?.written_by?.name}</h6>
                    </div>
                    :
                    <div className='mt-1 '>
                        <h6  className='font_normal line-clamp-3 font-[700] text-[#000]/80 text-[12px] 2xl:text-[15px] break-word'>{b?.title}</h6>
                        <h6 className='font_normal text-[11px] 2xl:text-[14px] font-[700] text-[#027d9b]'>{(b?.tags !== undefined && b?.tags?.length > 0) && b?.tags[0]?.name}</h6>
                    </div>
                    }
                   </div>
                  
                </div>    
            ))}

            {datas?.datas?.slice(4,8)?.map((b,i)=>(
                <div data-aos="fade-right" onClick={()=>openDetail(b)} className={`${i == 0 ? 'col-span-1 md:col-span-2' : 'col-span-1'} w-[100%] mb-4 md:mb-0 relative cursor-pointer`}>
                   {i == 0 ? <div className='bg-slate-100 h-[260px]' /> :
                   <img src={`${process.env.REACT_APP_AWS_IMAGE_URL}${b?.blog_image}`} className={` ${i == 0 ? 'h-[260px]' : 'h-[160px]'} w-[100%]`} />}
                   <div>

                    {i == 0 ? 
                    <div className='absolute top-[20%]'>
                        <h6 className='font_normal font-[700] text-[#027d9b] capitalize  text-[18px] 2xl:text-[21px] break-all w-[85%] ml-5 pt-0'>{b?.title}</h6>
                        <h6 className='font_normal font-[500] text-[#000] capitalize  text-[13px] 2xl:text-[16px] break-all w-[85%] ml-5 pt-4'>{b?.motive}</h6>
                        <h6  className='font_normal mb-2 ml-5 font-[700] text-[#027d9b] text-[11px] 2xl:text-[14px] mt-2'>{(b?.tags !== undefined && b?.tags?.length > 0) && b?.tags[0]?.name}</h6>
                    </div>
                    :
                    <div className='mt-1'>
                    <h6  className='font_normal line-clamp-3 font-[700] text-[#000]/80 text-[12px] 2xl:text-[15px] break-word'>{b?.title}</h6>
                    <h6 className='font_normal text-[11px] 2xl:text-[14px] font-[700] text-[#027d9b]'>{(b?.tags !== undefined && b?.tags?.length > 0) && b?.tags[0]?.name}</h6>
                    </div>
                    }

                  
                    
                   </div>
                  
                </div>    
            ))}

            {datas?.datas?.slice(8)?.map((b,i)=>(
                <div data-aos="fade-up" onClick={()=>openDetail(b)} className={`w-[100%]  mb-4 md:mb-0 relative cursor-pointer`}>
                   <img src={`${process.env.REACT_APP_AWS_IMAGE_URL}${b?.blog_image}`} className={'h-[160px] w-[100%]'} />
                    <div className='mt-1'>
                    <h6  className='font_normal line-clamp-3 font-[700] text-[#000]/80 text-[12px] 2xl:text-[15px] break-word'>{b?.title}</h6>
                    <h6 className='font_normal text-[11px] 2xl:text-[14px] font-[700] text-[#027d9b]'>{(b?.tags !== undefined && b?.tags?.length > 0) && b?.tags[0]?.name}</h6>
                    </div>
                </div>    
            ))}

            

        </div>

        {(datas?.pagination?.total > datas?.pagination?.limit) &&
        <div className='mx-auto flex items-center justify-center my-[5%] w-full'>
        <Pagination size='small' onChange={(v)=>setpage(v)} total={datas?.pagination?.total} pageSize={datas?.pagination?.limit} />
        </div>}
        </div>
    </div>
  )
}

export default Blogs